import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, map, mergeMap } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipType } from '../../../../core/betslip-type';
import { PickId } from '../../../../core/picks/pick-id';
import { selectTabbedPickErrorsFactory } from '../../selectors';
import { ErrorViewModelService } from '../../services/error-viewmodel.service';
import { SummaryErrorsViewModel } from '../common/errors-container.component';

@Component({
    selector: 'bs-tabbed-pick-errors',
    template: '<bs-errors-container [viewModel]="viewModel$ | async" (errorDisplayChange)="errorDisplayChange.emit($event)"></bs-errors-container>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TabbedPickErrorsComponent implements OnInit {
    @Output() errorDisplayChange = new EventEmitter<boolean>();
    @Input() pickId: PickId;
    @Input() betslipType: BetslipType;

    viewModel$: Observable<SummaryErrorsViewModel>;

    constructor(
        private store: Store<IBetslipRootState>,
        private viewModelService: ErrorViewModelService,
    ) {}

    ngOnInit(): void {
        const errors$ = this.store
            .select(selectTabbedPickErrorsFactory(this.pickId, this.betslipType))
            .pipe(mergeMap((errors) => this.viewModelService.getErrorViewModels$(errors)));

        this.viewModel$ = errors$.pipe(
            map((errors) => ({
                errors,
                betslipType: this.betslipType,
            })),
        );
    }
}
